module.exports = __webpack_public_path__ + "img/level_one_hover.5e7c1be2.png";